/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Share_TitleInputs */

const en_us2_workout_share_share_title = /** @type {(inputs: Workout_Share_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My workout`)
};

const pt_br2_workout_share_share_title = /** @type {(inputs: Workout_Share_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu treino`)
};

const es_419_workout_share_share_title = /** @type {(inputs: Workout_Share_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi entrenamiento`)
};

const pt_pt2_workout_share_share_title = /** @type {(inputs: Workout_Share_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu treino`)
};

const fr_fr2_workout_share_share_title = /** @type {(inputs: Workout_Share_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma séance`)
};

const de_de2_workout_share_share_title = /** @type {(inputs: Workout_Share_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Training`)
};

const it_it2_workout_share_share_title = /** @type {(inputs: Workout_Share_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio allenamento`)
};

/**
* | output |
* | --- |
* | "My workout" |
*
* @param {Workout_Share_Share_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_share_title = /** @type {((inputs?: Workout_Share_Share_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Share_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_share_title(inputs)
	if (locale === "es-419") return es_419_workout_share_share_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_share_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_share_title(inputs)
	if (locale === "de-DE") return de_de2_workout_share_share_title(inputs)
	if (locale === "it-IT") return it_it2_workout_share_share_title(inputs)
	return en_us2_workout_share_share_title(inputs)
});
export { workout_share_share_title as "workout-share.share_title" }